import { AssetRegistrationDetailsResponse } from '../models/asset-details-response.model';

// Shown before the first load and after a failed one, so the card renders its labels
// instead of collapsing while the values are unknown.
export const EMPTY_REGISTRATION: AssetRegistrationDetailsResponse = {
  assetName: '',
  plateNumber: null,
  mainColour: null,
  mainColourHex: null
};

// The odometer label is anchored to the end of the lifecycle bar fill. This floor keeps it
// readable inside the bar when an asset has barely travelled.
export const MIN_LIFECYCLE_VALUE_PERCENT = 30;
